import { IconDefinition } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"

export function getPriorityIcon(priority: number | null): IconDefinition {
    if (priority === 1) {
        return faIcon({ name: "fire", style: "solid" })
    } else if (priority === 2) {
        return faIcon({ name: "solid-priority-high", style: "kit" })
    } else if (priority === 3) {
        return faIcon({ name: "duotone-solid-priority-medium", style: "kit-duotone" })
    } else if (priority === 4) {
        return faIcon({ name: "duotone-solid-priority-low", style: "kit-duotone" })
    } else {
        return faIcon({ name: "hyphen", style: "regular" })
    }
}

export function getPriorityLabel(priority: number | null): string {
    if (priority === 1) {
        return "Urgent"
    } else if (priority === 2) {
        return "High"
    } else if (priority === 3) {
        return "Medium"
    } else if (priority === 4) {
        return "Low"
    } else {
        return "No Priority"
    }
}
